import { render, staticRenderFns } from "./PecasLista.vue?vue&type=template&id=5ccf8ae1&scoped=true&"
import script from "./PecasLista.vue?vue&type=script&lang=js&"
export * from "./PecasLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccf8ae1",
  null
  
)

export default component.exports